import { Dates } from "src/modules/utils/shared/dates";
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from 'class-transformer';
import { SmBaseEntity } from 'src/modules/sm-base/shared/sm-base-entity.model';
import { Column, Entity, ManyToOne } from 'typeorm';
import { ClassRegister } from './class-register.entity';

@Entity()
export class ClassFieldTrip extends SmBaseEntity {

    @ManyToOne(() => ClassRegister, (o: ClassRegister) => o.sickNotes, { onDelete: "CASCADE", nullable: false, orphanedRowAction: "delete"})
    classRegister: ClassRegister;

    @Column()
    @Type(() => Date)
    fromDate: Date;

    @Column({default: -1})
    fromHour: number = -1;

    @Column()
    @Type(() => Date)
    toDate: Date;

    @Column({default: -1})
    toHour: number = -1;

    @Column({default: ""})
    title: string = "";

    @Column({default: ""})
    type: string = "";

    @Column({default: ""})
    educationalProject: string = "";

    @Column({default: ""})
    transportation: string = "";

    @Column({default: ""})
    inClassPupilsSupervision: string = "";

    @Column()
    approvalToken: string = "";

    @Column({ nullable: true })
    @Type(() => Date)
    approvedDate: Date;

    @Column()
    approvedBy: string = "";

    includes(date: Date, hour: number): boolean {
        let fromHour = Dates.eq(date, this.fromDate) ? this.fromHour : -1;
        let toHour = Dates.eq(date, this.toDate) ? this.toHour : -1;
        return Dates.geq(date, this.fromDate) && Dates.leq(date, this.toDate) && (fromHour == -1 || fromHour <= hour) && (toHour == -1 || toHour >= hour);
    }

}